<template>
    <div class="goal-dropdown">
        <button
            ref="button"
            type="button"
            :class="buttonClass"
            :disabled="disabled"
        >
            {{ displayedValue }}
        </button>
    </div>
</template>

<script>
export default {
    name: 'predictor-american-football-score-selector',
    props: {
        // Disabled status
        disabled: {
            type: Boolean,
            required: true,
        },
        // Current value
        value: {
            type: String,
            required: false,
            default: '',
        },
        isResultDefined: {
            type: Boolean,
            default: false,
        },
        isCorrectDifference: {
            type: Boolean,
            default: false,
        },
        userHasVoted: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        displayedValue() {
            return this.value ?? '+';
        },

        buttonClass() {
            const wrongScoreRangePrediction = this.isResultDefined && this.userHasVoted && !this.isCorrectDifference;
            const correctScoreRangePrediction = this.isResultDefined && this.userHasVoted && this.isCorrectDifference;

            return [
                'goal-dropdown__button', {
                    'goal-dropdown__button--red': wrongScoreRangePrediction,
                },
                {
                    'goal-dropdown__button--green': correctScoreRangePrediction,
                },
            ];
        },
    },
};
</script>

<style lang="scss" scoped>
.goal-dropdown {
    &__button {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 9rem;
        height: 5.5rem;
        padding: 0;
        border: initial;
        border-radius: 49px;
        background-color: $blue-dark-color;
        outline: none;
        cursor: pointer;
        font-family: Nunito;
        font-weight: bold;
        font-size: 2.8rem;
        user-select: none;

        @include min-width(md) {
            width: 9rem;
            height: 5.5rem;
            font-size: 3rem;
        }

        &:disabled {
            pointer-events: none;
        }

        &:focus,
        &--focused {
            border: 1px solid rgba($blue-ribbon-color, 0.5);
        }

        &--red,
        &--red:disabled {
            color: $torch-red-color;
            border-color: $torch-red-color;
            border-width: 1px;
            border-style: solid;
            background-color: rgba($torch-red-color, 0.1);
        }

        &--green,
        &--green:disabled {
            color: $lime-green-color;
            border-color: $lime-green-color;
            border-width: 1px;
            border-style: solid;
            background-color: rgba($lime-green-color, 0.1);
        }
    }
}
</style>